var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.emailUrl}},[_c('span',{staticClass:"tag reportBug"},[_vm._v(" Report bugs ")])])}
var staticRenderFns = []

export { render, staticRenderFns }